module.exports = __webpack_public_path__ + "img/contacto.c4d56c60.svg";